export default __webpack_public_path__ + "static/media/aboutUs.306ebb60.png";